import createElement from '../logical-components/createElement';
import './scss/poweredBy.scss';
// Simple section for the powered by footer
var Custom = function (options) {
    var view = options.section.view();
    var wrapper = createElement('div', [
        { type: 'class', value: '_mnslq-custom' },
    ]);
    if (typeof view === 'string') {
        wrapper.innerHTML = view;
    }
    else {
        wrapper.appendChild(view);
    }
    return wrapper;
};
export default Custom;
